import * as React from "react";

const OpenSeaIcon = () => {
  return (
    <svg
      version="1.0"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1269.8 892.9"
      style={{ enableBackground: "new 0 0 1269.8 892.9" }}
      xmlSpace="preserve"
    >
      <path
        fill="#2081E2"
        d="M988.9,446.4c0,195.5-158.5,354-354,354s-354-158.5-354-354s158.5-354,354-354S988.9,250.9,988.9,446.4z"
      />
      <path
        fill="#FFFFFF"
        d="M455.5,458.3l1.5-2.4l92.1-144.1c0.9-1.5,2.9-1.9,4.3-1c0.5,0.3,0.9,0.8,1.2,1.4
	c15.4,34.5,28.7,77.4,22.4,104.1c-2.7,11-9.9,25.9-18.1,39.6c-1,2-2.2,4-3.5,5.9c-0.6,0.9-1.6,1.4-2.6,1.4h-94.7
	c-1.7,0-3.2-1.4-3.2-3.1C455,459.5,455.2,458.9,455.5,458.3z"
      />
      <path
        fill="#FFFFFF"
        d="M866,485.1v22.8c0,1.3-0.8,2.5-2,3c-7.1,3-31.5,14.3-41.7,28.4c-25.9,36-45.7,87.6-89.9,87.6H547.9
	c-65.4,0-118.4-53.2-118.4-118.8v-2.1c0-1.7,1.4-3.2,3.2-3.2h102.9c1.9,0.1,3.4,1.7,3.4,3.6c0,0.1,0,0.2,0,0.3
	c-0.7,6.8,0.5,13.7,3.7,19.8c6.1,12.3,18.7,20.1,32.4,20.1H626v-39.8h-50.3c-1.8,0-3.2-1.5-3.2-3.3c0-0.6,0.2-1.3,0.6-1.8
	c0.5-0.8,1.2-1.7,1.8-2.7c4.8-6.8,11.6-17.3,18.3-29.2c4.8-8.2,9-16.6,12.7-25.4c0.7-1.6,1.3-3.2,1.9-4.7c1-2.8,2-5.3,2.7-7.9
	c0.7-2.2,1.3-4.5,1.9-6.6c1.7-7.6,2.5-15.4,2.4-23.2c0-3.2-0.1-6.5-0.4-9.6c-0.1-3.5-0.6-6.9-1-10.4c-0.3-3.1-0.8-6.1-1.4-9.2
	c-0.7-4.6-1.8-9.2-2.9-13.8l-0.4-1.8c-0.9-3.2-1.6-6.2-2.6-9.3c-2.9-9.9-6.2-19.6-9.7-28.7c-1.3-3.6-2.7-7.1-4.2-10.5
	c-2.1-5.2-4.3-9.9-6.3-14.4c-1-2-1.9-3.9-2.8-5.8c-1-2.1-2-4.3-3-6.3c-0.7-1.6-1.6-3-2.1-4.5l-6.2-11.5c-0.6-0.9-0.3-2.2,0.7-2.7
	c0.5-0.3,1.1-0.4,1.6-0.2l38.9,10.6h0.1c0.1,0,0.1,0,0.1,0l5.1,1.4l5.6,1.6l2.1,0.6v-23.1c-0.1-11.1,8.9-20.2,20-20.2c0,0,0,0,0,0
	c5.3,0,10.4,2.1,14.1,5.9c3.8,3.8,5.9,8.9,5.9,14.3v34.3l4.1,1.2c0.3,0.1,0.7,0.3,1,0.5c1,0.8,2.5,1.9,4.3,3.3c1.5,1.2,3,2.6,4.9,4
	c3.7,3,8.2,6.9,13.1,11.4c1.3,1.1,2.6,2.3,3.7,3.4c6.3,5.9,13.4,12.8,20.2,20.4c1.9,2.1,3.7,4.3,5.6,6.6s3.9,4.6,5.6,6.9
	c2.3,3.1,4.8,6.2,6.9,9.5c1,1.6,2.2,3.2,3.2,4.7c2.8,4.2,5.2,8.5,7.5,12.8c1,2,2,4.2,2.9,6.3c2.6,5.6,4.5,11.5,5.9,17.6
	c0.4,1.3,0.7,2.6,0.8,3.9v0.3c0.4,1.8,0.6,3.6,0.7,5.5c0.6,6.1,0.3,12.2-1,18.1c-0.6,2.6-1.3,5.1-2.1,7.6c-0.9,2.5-1.8,5-2.9,7.5
	c-2.2,5.2-4.8,10.1-7.8,14.8c-1,1.7-2.1,3.6-3.3,5.3s-2.6,3.6-3.7,5.3c-1.6,2.2-3.3,4.5-5.1,6.5c-1.5,2.2-3.2,4.2-4.9,6.2
	c-2.4,2.9-4.8,5.6-7.2,8.2c-1.5,1.7-3,3.5-4.6,5c-1.6,1.7-3.2,3.3-4.6,4.8c-2.4,2.4-4.5,4.3-6.2,5.9l-4,3.7
	c-0.6,0.5-1.4,0.8-2.1,0.8h-31v39.8h39c8.7,0,17.1-3.1,23.7-8.8c8.5-7.4,16.6-15.3,24.1-23.7c0.4-0.4,0.9-0.8,1.5-0.9L862,482
	c1.7-0.5,3.4,0.5,3.9,2.2C866,484.5,866,484.8,866,485.1z"
      />
    </svg>
  );
};

export default OpenSeaIcon;
